import React, { useState } from 'react'
import DeleteIcon from '@material-ui/icons/Delete';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import ImageCropModal from '../modals/ImageCropModal';
import { useDispatch } from 'react-redux';
import { removePhoto } from '../../store/Actions/appActions';
import { Resizable } from "re-resizable";
const style = {
    background: "#d8dbe0"
};

const PhotoHolder = ({ item, updatePhotoHolderSize, removeItem, updatePhoto }) => {
    const dispatch = useDispatch();
    const [imagePath, setImagePath] = useState(null);
    const [openCrop, setCropOpen] = useState(false);
    let width = item.width && parseInt(item.width.substring(0, item.width.length - 2));
    let height = item.height && parseInt(item.height.substring(0, item.height.length - 2));

    const onResize = (e, direction, ref, d) => {
        const data = {
            property_id: item.property_id,
            width: width + parseInt(d.width),
            height: height + parseInt(d.height),
        }
        updatePhotoHolderSize(data);
    }
    const handleCloseCrop = () => {
        setCropOpen(false);
    }
    const convertToBase64 = file => {
        const data = {
            id: item.property_id,
            photo_url: file
        }
        updatePhoto(data);
        setCropOpen(false)
    }
    const handleImageChange = async (e) => {
        var file = e.target.files[0];
        // getBase64(file)
        //     .then(src => {
        //         file["base64"] = src;
        //         const data = {
        //             id:item.property_id,
        //             photo_url:src
        //         }
        //         updatePhoto(data)
        //     })
        //     .catch(err => {
        //         console.log(err);
        //     });
        var src = URL.createObjectURL(file);
        setImagePath(src);
        setCropOpen(true)
    }

  const removePhoto1 = () =>{
    const data = {
        id: item.property_id
    }
    console.log(data);
    dispatch(removePhoto(data));
  }


    return (
        <Resizable
            //lockAspectRatio={true}
            style={style}
            className="no-cursor "
            defaultSize={{
                width: item.width,
                height: item.height
            }}
            onResizeStop={onResize}
        >
            <div className={`handle photo_handle ${item.image_url === null && 'noPhoto'}`} >
                {item.image_url !== null && <>
                <img src={item.image_url} alt="" />
                <button className='img-remove' onClick={removePhoto1}><DeleteIcon/></button>
                </>}

                {
                    item.image_url === null && <>
                        <label for="getFile">
                            <PhotoCameraIcon fontSize="large" />
                            <span>Select File</span>
                            <ImageCropModal open={openCrop} cropWidth={item.width} cropHeight={item.height} imagePath={imagePath} handleClose={handleCloseCrop} convertToBase64={convertToBase64} />
                        </label>
                        <input type='file' id="getFile" onChange={handleImageChange} />
                    </>
                }

            </div>
            {
                item.image_url === null && <div className='rm-btn rm-2 rm-photo'><button type='button' className='zIndex30' onClick={() => removeItem(item.property_id)}><DeleteIcon /></button></div>
            }

        </Resizable>
    )
}

export default PhotoHolder